<template>
    <a-config-provider :locale="zh_CN">
        <router-view class="main-block" />
    </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment'; 
import 'moment/locale/zh-cn';
import { defineComponent, onMounted, ref } from 'vue';
import { getCookie, getLocalItem, setLocalItem } from './until/tools';
import Http from './until/http';
moment.locale('zh-cn');
export default defineComponent({
    setup() {
        const nowHeadersPaths = ref(['/agreement','/login/login_basic','/login/bind','/login/guidance','/login/bind_phone']);
        onMounted(()=>{
            let sid = getCookie('z_sid');
            if(sid) {
                let userInfo = getLocalItem('userInfo');
                if(!userInfo) {
                    Http.getUserInfo().then(res=>{
                        if(res.userInfo) {
                            setLocalItem('userInfo',res.userInfo);
                        }
                    });
                }
            }
            
        })
        return {
            nowHeadersPaths,
            zh_CN,
        }
    }
})
</script>
<style lang="scss">
@import './scss/base.scss';
</style>
